import React from "react";
import CustomButton from "@/components/ratl/utility/CustonButton";
import { RT_DEMO_CAL_URL } from "@/data";
import { useFloat } from "@/lib";

const NavbarCTA: React.FC = () => {
  const { float, handleFloat } = useFloat([false, false]);
  return (
    <CustomButton
      text={"Book a Demo"}
      animationRequired={false}
      bgType={"solid"}
      onClick={() => {
        window.location.href = RT_DEMO_CAL_URL;
      }}
      onMouseEnter={() => handleFloat(true, 1)}
      onMouseLeave={() => handleFloat(false, 1)}
      controller={float[1]}
      btnSize="small"
      isStudioBtn={false}
      className="px-4 py-2 text-sm transition w-fit rounded-lg border-solid border-[1px] hover:bg-transparent hover:text-black hover:border-solid hover:border-black hover:border-[1px]"
    />
  );
};

export default NavbarCTA;
